import { render } from "./AlertMsg.vue?vue&type=template&id=b0e724e0"
import script from "./AlertMsg.vue?vue&type=script&lang=js"
export * from "./AlertMsg.vue?vue&type=script&lang=js"

import "./AlertMsg.vue?vue&type=style&index=0&id=b0e724e0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__